//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// @ is an alias to /src

import { mapState } from 'vuex'
export default {
  name: 'SessionList',
  data() {
    return {
      list: [
        {
          headimgurl: '',
          nickname: '艾爾興',
          job: '主任專家',
          text: '擅長領域：xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx'
        },
        {
          headimgurl: '',
          nickname: '艾爾興',
          job: '主任專家',
          text: '擅長領域：xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx'
        },
        {
          headimgurl: '',
          nickname: '艾爾興',
          job: '主任專家',
          text: '擅長領域：xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx'
        }
      ]
    }
  },
  components: {
  },
  computed: mapState({
    user: state => state.user.user
  }),
  mounted() {
  },
  methods: {
    startChat () {
      this.$router.push('/chat')
    }
  }
}
